import PropTypes from "prop-types"
import { FiberManualRecord } from "@mui/icons-material"
import { THRESHOLD_STATUS } from "helpers/threshold"
import "./styles.scss"

const { OVER, OVER_DOUBLE } = THRESHOLD_STATUS

function ThresholdIcon({ threshold }) {
  let icon
  switch (threshold) {
    case OVER:
      icon = <div className="threshold-icon-wrapper">
        <FiberManualRecord />
      </div>
      break
    case OVER_DOUBLE:
      icon = <div className="threshold-icon-wrapper double-threshold">
        <FiberManualRecord />
        <FiberManualRecord />
      </div>
  }

  return <span className="components_threshold-icon">{icon}</span>
}

ThresholdIcon.propTypes = {
  threshold: PropTypes.string,
}

export default ThresholdIcon
